import * as React from 'react';
import {connect} from 'react-redux';
import {Typography, WithStyles, withStyles} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { EditActionStyle } from '../EditAction.style';
import { ISchedule, IScheduleTemplate, TemplateName } from '@app-types/websocket/schedule.types';
import { IDateRange } from '@containers/calendar/calendar.helpter';
import { applyChanges, scheduleTemplates } from './WizardCalc';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { MAX_CUSTOM_TEMPLATE_DAYS } from '@constants/customTemplate';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  daysToRepeatString:string,
  daysToRepeat:number
}

interface IProps extends WithStyles<typeof EditActionStyle> {
  offset:number;
  family:IFamilyMember[];
  selectedTemplate:IScheduleTemplate;
  schedule:ISchedule|undefined;
  selectTmplate:(template:IScheduleTemplate) => void;
  localization: 'se'|'en';
}

class WizardCust extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    
    this.state = {
      daysToRepeatString:""+props.selectedTemplate.days.length,
      daysToRepeat:props.selectedTemplate.days.length,
    };
  }

  public render() {
    const {classes, selectedTemplate, offset, schedule, localization} = this.props;

    if (schedule === undefined ) {
      return <div>unknown</div>
    }

    const parentA:IFamilyMember|undefined = this.props.family.find((mem) => mem.id === schedule.data.parentA);
    const parentB:IFamilyMember|undefined = this.props.family.find((mem) => mem.id === schedule.data.parentB);

    if (parentA === undefined || parentB === undefined) {
      return <div>unknown</div>
    }

    let correctedTemplate: Array<("A" | "B")> ;

    if (localization === 'en') {
      correctedTemplate = [
        selectedTemplate.days[selectedTemplate.days.length - 1], 
        ...selectedTemplate.days.slice(0, selectedTemplate.days.length - 1)
      ];
    } else {
      correctedTemplate = selectedTemplate.days;
    }

    return (
      <div className={classes.pane+" "+classes.paneStep} style={{ left: (offset*100)+"%", opacity:offset===0?1:0}}>
        <div>{tn.lang.calWizardRepeat}</div>
        <input type="number" min={7} max={MAX_CUSTOM_TEMPLATE_DAYS}
          value={this.state.daysToRepeatString} className={classes.textInput}
          onChange={(event) => this.handleRepeatChange(event.target.value)}/>
        <div style={{width:'100%', minHeight:'20px'}} />
        <div className={classes.wizardCal}>
          {this.props.localization === 'en' && <div className={classes.wizardDayHeader} key="7">{tn.lang.sun}</div>}
          <div className={classes.wizardDayHeader}>{tn.lang.mon}</div>
          <div className={classes.wizardDayHeader}>{tn.lang.tue}</div>
          <div className={classes.wizardDayHeader}>{tn.lang.wed}</div>
          <div className={classes.wizardDayHeader}>{tn.lang.thu}</div>
          <div className={classes.wizardDayHeader}>{tn.lang.fri}</div>
          <div className={classes.wizardDayHeader}>{tn.lang.sat}</div>
          {this.props.localization === 'se' && <div className={classes.wizardDayHeader} key="7">{tn.lang.sun}</div>}
          {correctedTemplate.map((day, index) => <div key={index} style={{backgroundColor:(day==="A"?parentA.color:parentB.color)}}
            onClick={() => this.handleSwapDay(index)}
            className={classes.wizardDay}/>)}
        </div>
        <div style={{fontSize: '16px', fontWeight: 500, alignSelf: 'center'}}>{tn.lang.calWizardWhereSleeps}</div>
        <div style={{fontSize: '13px', opacity: 0.7, alignSelf: 'center', textAlign: 'center', paddingTop: '4px'}}>
          {tn.lang.calWizardWhereSleepsTip}
        </div>
        <div style={{display:'flex', flexDirection:'row', gap:'10px', paddingTop: '32px'}}>
          <div  style={{display:'flex', flexDirection:'row', alignItems: 'center', gap: '3px'}}>
            {tn.avatar(this.props.family, parentA.id,{width:32, height:32})}
            <Typography variant="body2">{parentA.firstName}</Typography>
          </div>
          <div  style={{display:'flex', flexDirection:'row', alignItems: 'center', gap: '3px'}}>
            {tn.avatar(this.props.family, parentB.id,{width:32, height:32})}
            <Typography variant="body2">{parentB.firstName}</Typography>
          </div>
          
        </div>
      </div>
    );
  }

  private handleRepeatChange(repeat:string) {
    let newRepeat:number = Number.parseInt(repeat, 10);
    if (!(Number.isFinite(newRepeat))) {
      newRepeat = 7;
    } else if (newRepeat < 7) {
      newRepeat = 7;
    } else if (newRepeat > MAX_CUSTOM_TEMPLATE_DAYS) {
      newRepeat = MAX_CUSTOM_TEMPLATE_DAYS;
    }
    this.setState({daysToRepeat:newRepeat, daysToRepeatString:repeat});
    const days:Array<"A" | "B"> = this.props.selectedTemplate.days.slice(0,newRepeat);
    while (days.length < newRepeat) {
      days.push("A");
    }
    this.props.selectTmplate({title:this.props.selectedTemplate.title, type:this.props.selectedTemplate.type, days})
  }

  private handleSwapDay(indexGiven:number) {
    const days:Array<"A" | "B"> = [...this.props.selectedTemplate.days];

    let index:number = indexGiven;
    if (this.props.localization === 'en') {
      if (indexGiven === 0) {
        index = days.length - 1;
      } else {
        index = (indexGiven-1);
      }
      
    }
    if (index < days.length) {
      days[index] = (days[index] === "A"?"B":"A");
    }
    this.props.selectTmplate({title:this.props.selectedTemplate.title, type:this.props.selectedTemplate.type, days})
  }

}

export default withStyles(EditActionStyle)(WizardCust);



// WEBPACK FOOTER //
// ./src/components/calendar2/editPane/editActions/Wizard/WizardCust.tsx